const showAsUnavailable = (bannerSet, forbidWhenLock) =>
  forbidWhenLock && Boolean(bannerSet.lockOwner && bannerSet.lockOwner.length);

export default showAsUnavailable;
